import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import { loadSpecialCompletion } from '../../actions';

export function* watchSpecial() {
  yield takeEvery('LOAD_SPECIAL', function*({ specialId }) {
    const options = {
      url: `/sfapi/topics/${specialId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadSpecialCompletion(specialId, result.data, result.error));
  });
}

export default function* specialSaga() {
  yield all([fork(watchSpecial)]);
}
